
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/technological",
      function () {
        return require("private-next-pages/events/technological.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/technological"])
      });
    }
  